var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboReturnSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74921 4.48252H3.28816L4.96488 2.8121C5.02161 2.75537 5.05943 2.67342 5.05943 2.59148V1.69638C5.05943 1.41903 4.71905 1.27405 4.52364 1.47576L1.09455 4.88594C0.968483 5.01201 0.968483 5.20742 1.09455 5.33348L4.51103 8.74366C4.70644 8.93907 5.04683 8.80039 5.04683 8.52304V7.63425C5.04683 7.55231 5.02161 7.47036 4.95858 7.40733L3.28186 5.73691H9.79334C11.7285 5.73691 13.4557 7.12367 13.7015 9.04623C13.9977 11.3722 12.1887 13.3578 9.92571 13.3578H3.22963C3.05313 13.3578 2.91445 13.4965 2.91445 13.673V14.3033C2.91445 14.4798 3.05313 14.6185 3.22963 14.6185H9.93201C12.8442 14.6185 15.1891 12.1538 14.9874 9.19751C14.8046 6.50593 12.4471 4.47621 9.74921 4.47621V4.48252Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboReturnSmall);
export default __webpack_public_path__ + "static/media/FBOReturnSmall.caa215ba7c8f5f1c5f0a9892be73883c.svg";
export { ForwardRef as ReactComponent };